import { Box } from '@mui/material';
import { styles } from '../assets/styles';

export default function InfoText() {
  const showInfo = JSON.parse(localStorage.getItem('showed_text'));

  return (
    <Box className="pokemon-info-text-container" sx={styles.infoTextContainer}>
      <Box className={showInfo ? '' : 'fade-in-text'} sx={styles.infoTextContainerShow}>
        <Box className="pokemon-info-gen pokemon-info-column" sx={styles.pokeInfoColumnPadding}>
          <p style={styles.infoTextGen}>Gen</p>
        </Box>

        <Box className="pokemon-info-types pokemon-info-column" sx={styles.pokeInfoColumnPadding2}>
          <p style={styles.infoTextTypes}>Types(s)</p>
        </Box>

        <Box className="pokemon-info-weight pokemon-info-column" sx={styles.pokeInfoColumnPadding2}>
          <p style={styles.infoTextAbilities}>Abilities</p>
        </Box>

        <Box className="pokemon-info-weight pokemon-info-column" sx={styles.pokeInfoColumnPadding2}>
          <p style={styles.infoTextWeight}>Weight</p>
        </Box>

        <Box className="pokemon-info-height pokemon-info-column" sx={styles.pokeInfoColumnPadding2}>
          <p style={styles.infoTextHeight}>Height</p>
        </Box>

        <Box className="pokemon-info-stats pokemon-info-column" sx={styles.pokeInfoColumnPadding2}>
          <p style={styles.infoTextStats}>BaseStats</p>
        </Box>
      </Box>
    </Box>
  );
}
